import { render, staticRenderFns } from "./PanelTypeDisplay.vue?vue&type=template&id=7cb3040e&scoped=true"
import script from "./PanelTypeDisplay.vue?vue&type=script&lang=js"
export * from "./PanelTypeDisplay.vue?vue&type=script&lang=js"
import style0 from "./PanelTypeDisplay.vue?vue&type=style&index=0&id=7cb3040e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb3040e",
  null
  
)

export default component.exports